import { type AxiosError, HttpStatusCode } from "axios";

import { getErrorMessage } from "@vega-api/custom/utils/errorHandling";
import { useCompleteTask } from "@vega-api/generated/lp-tasks/lp-tasks";
import { useToast } from "@vega-core/components/Toast/useToast";
import { useStatusPopup } from "@vega-core/hooks/useStatusPopup";
import { m } from "@vega-core/paraglide/messages";

export const useCompleteTaskV2 = () => {
  const { setError } = useStatusPopup();
  const showToast = useToast();

  const {
    mutate: completeTask,
    isPending,
    ...rest
  } = useCompleteTask({
    mutation: {
      onError: (error: AxiosError) => {
        if (error.response?.status === HttpStatusCode.BadRequest) {
          setError({
            description: m.errors_unexpectedError(),
            title: m.errors_modalTitle(),
          });

          return;
        }

        const { title, description } = getErrorMessage(error);

        showToast({ title, description, variant: "destructive" });
      },
    },
  });

  return {
    isPending,
    completeTask,
    ...rest,
  };
};
